import { render, staticRenderFns } from "./jiancha-edit.vue?vue&type=template&id=2a72f8c5&scoped=true&"
import script from "./jiancha-edit.vue?vue&type=script&lang=ts&"
export * from "./jiancha-edit.vue?vue&type=script&lang=ts&"
import style0 from "./jiancha-edit.vue?vue&type=style&index=0&id=2a72f8c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a72f8c5",
  null
  
)

export default component.exports